import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { PersonaActions } from './persona.actions';

@Injectable({
  providedIn: 'root'
})
export class PersonaEffects {
  sendPersonaEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendPersonaEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(PersonaActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
